export const ASSIGNMENT = 'assignment'
export const CUSTOMER = 'customer'
export const SENDER_ADDRESS = 'sender_address'
